import RankingGrammarEdit from "./RankingGrammarEdit";

export default { Edit: RankingGrammarEdit };
